import React, { Component } from 'react';
import { TextButton, IconType } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import styles from '../style.scss';

export default class AddDomain extends Component {

    render() {

        const { showAddDomain, firstDomain, onClick, text } = this.props;

        return showAddDomain ? (
            <div className={classNames(firstDomain ? styles.addFirstDomainManager : styles.addDomainManager)}>
                <TextButton
                    iconType={IconType.add}
                    text={text}
                    onClick={onClick} />
            </div>) : null;
    }
}